import { Box, Divider, TextField, Typography } from "@mui/material";
import DialogContainer from "../../../../../../components/dialog-container/dialog-container";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { updateProcedureCancellationRequest } from "../../../../../../utils/APICalls";
import Loading from "../../../../../../components/loading/loading";
import { useDispatch } from "react-redux";
import { getProcessesProcedureRequest } from "../../../../../../redux/clients/slice";
import ErrorNotification from "../../../../../../components/error-notification/error-notification";

type props = {
  showDialog: boolean;
  closeDialog: any;
  data?: any;
  clientId: string;
};

export default function EditCancellation({
  showDialog,
  closeDialog,
  data,
  clientId,
}: props) {
  useEffect(() => {}, []);

  const [showLoading, setShowLoading] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    cancellationProcedure: Yup.string().required("This Field can't be Empty"),
    contactNoShowProcedure: Yup.string().required("This Field can't be Empty"),
  });

  const formik = useFormik({
    initialValues: {
      cancellationProcedure: data?.cancellation,
      contactNoShowProcedure: data?.contactNoShow,
    },
    validationSchema,
    onSubmit: (values) => {
      updateProcedureCancellation(values);
    },
  });

  const updateProcedureCancellation = async (payload: any) => {
    setShowLoading(true);
    const response = await updateProcedureCancellationRequest(
      clientId,
      payload
    );
    setShowLoading(false);
    if (response?.status === 204) {
      dispatch(getProcessesProcedureRequest({ id: clientId }));
      closeDialog();
    } else if (response?.status === 400) {
      setShowErrorNotification(true);
      setErrorMessage(response?.data?.detail);
    }
  };

  return (
    <>
      <DialogContainer
        closeDialog={closeDialog}
        showDialog={showDialog}
        onSubmit={formik.handleSubmit}
        title="Client - Processes & Procedures - Cancellation"
      >
        <form onSubmit={formik.handleSubmit}>
          <Box py={2.5} display={"flex"}>
            <Typography className="model-label-txt">
              Cancellation Procedure
            </Typography>
            <Box sx={{ width: "calc(100% - 180px)" }}>
              <TextField
                fullWidth
                id="outlined-multiline-static"
                multiline
                name="cancellationProcedure"
                value={formik.values.cancellationProcedure}
                onChange={formik.handleChange}
                error={
                  formik.touched.cancellationProcedure &&
                  Boolean(formik.errors.cancellationProcedure)
                }
                helperText={
                  formik.touched.cancellationProcedure &&
                  (formik.errors.cancellationProcedure as string)
                }
                rows={2}
              />
            </Box>
          </Box>
          <Divider />
          <Box py={2} display={"flex"}>
            <Typography className="model-label-txt">
              Contact No-Show Procedure
            </Typography>
            <Box sx={{ width: "calc(100% - 180px)" }}>
              <TextField
                fullWidth
                id="outlined-multiline-static"
                multiline
                rows={2}
                name="contactNoShowProcedure"
                value={formik.values.contactNoShowProcedure}
                onChange={formik.handleChange}
                error={
                  formik.touched.contactNoShowProcedure &&
                  Boolean(formik.errors.contactNoShowProcedure)
                }
                helperText={
                  formik.touched.contactNoShowProcedure &&
                  (formik.errors.contactNoShowProcedure as string)
                }
              />
            </Box>
          </Box>
        </form>
      </DialogContainer>
      <ErrorNotification
        show={showErrorNotification}
        message={errorMessage}
        onClose={() => setShowErrorNotification(false)}
      />
      {showLoading && <Loading />}
    </>
  );
}
